import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from "react";
import { useConstantValueInvariant } from "@contember/react-utils";
import { Component } from "../coreComponents/Component.js";
import { useBindingOperations } from "../accessorPropagation/useBindingOperations.js";
import { useMutationState } from "../accessorTree/useMutationState.js";
import { useHasEntity } from "../accessorPropagation/useHasEntity.js";
import { useEntityBeforePersist } from "../entityEvents/useEntityBeforePersist.js";
import { TreeRootIdProvider } from "../accessorPropagation/TreeRootIdProvider.js";
import { MarkerFactory } from "../queryLanguage/MarkerFactory.js";
import { useEnvironment } from "../accessorPropagation/useEnvironment.js";
import { EntityFieldMarkersContainer } from "../markers/EntityFieldMarkersContainer.js";
import { EntityFieldsWithHoistablesMarker } from "../markers/EntityFieldsWithHoistablesMarker.js";
const DeferredSubTrees = Component(
  (props) => {
    const { extendTree } = useBindingOperations();
    const isMutating = useMutationState();
    const [loadState, setLoadState] = useState({ name: "initial" });
    const [abortController] = useState(() => new AbortController());
    const signal = abortController.signal;
    const hasEntity = useHasEntity();
    useConstantValueInvariant(hasEntity);
    if (hasEntity) {
      useEntityBeforePersist(
        useCallback((getAccessor) => {
          if (getAccessor().existsOnServer) {
            return;
          }
          setLoadState({ name: "initial" });
        }, [])
      );
    }
    useEffect(() => {
      return () => {
        abortController.abort();
      };
    }, [abortController]);
    const environment = useEnvironment();
    useEffect(() => {
      if (isMutating || loadState.name !== "initial" || signal.aborted) {
        return;
      }
      setLoadState({ name: "loading" });
      const newFragment = /* @__PURE__ */ jsx(OnlyKeepSubTrees, { children: props.children });
      extendTree(newFragment, { signal, environment }).then((treeRootId) => !signal.aborted && setLoadState({ name: "success", treeRootId })).catch((error) => {
        if (signal.aborted) {
          return;
        }
        throw error;
      });
    }, [environment, extendTree, isMutating, loadState.name, props.children, signal]);
    switch (loadState.name) {
      case "initial":
      case "loading":
        return /* @__PURE__ */ jsx(Fragment, { children: props.fallback });
      case "success":
        return /* @__PURE__ */ jsx(TreeRootIdProvider, { treeRootId: loadState.treeRootId, children: props.children });
    }
  },
  {
    staticRender: (props) => /* @__PURE__ */ jsxs(Fragment, { children: [
      props.children,
      props.fallback
    ] }),
    generateBranchMarker: (props, fields, environment) => {
      const fieldsWithHoistablesMarker = MarkerFactory.createEntityFieldsWithHoistablesMarker(fields, environment);
      fieldsWithHoistablesMarker.subTrees?.clear();
      return fieldsWithHoistablesMarker;
    }
  },
  "DeferredSubTree"
);
const OnlyKeepSubTrees = Component(
  () => null,
  {
    generateBranchMarker: (props, fields) => {
      const emptyFields = MarkerFactory.createEntityFieldMarkersContainer(void 0);
      if (fields instanceof EntityFieldMarkersContainer) {
        return emptyFields;
      }
      return new EntityFieldsWithHoistablesMarker(emptyFields, fields.subTrees, void 0);
    }
  },
  "OnlyKeepSubTrees"
);
export {
  DeferredSubTrees
};
//# sourceMappingURL=DeferredSubTrees.js.map
